

export type QueryParam = string | number | boolean | Date | null | undefined;

export function encodeUrl(baseUrl: string, getParams?: Record<string, QueryParam> | null) {
    if (getParams == null) return baseUrl;

    const ret = [];
    for (const field in getParams) {
        const value = getParams[field];
        if (typeof value !== 'undefined' && value !== null) {
            ret.push(encodeQueryComponent(field) + '=' + encodeQueryComponent(value));
        }
    }
    return baseUrl + '?' + ret.join('&');
}

export function encodeQueryComponent(value: QueryParam) {
    const valueConverted = value instanceof Date ? value.toISOString() : value;
    const encoded = value != null ? encodeURIComponent(valueConverted!) : null;
    return encoded;
}
